import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SeguridadService } from '../servicios/seguridad.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationGuard implements CanActivate {

  constructor(private router: Router, private seguridadService: SeguridadService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const autoridades = route.data.autoridades;
    return this.validarPerfil(autoridades, state.url);
  }

  private validarPerfil(autoridades: string[], url: string): Observable<boolean> {
    return this.seguridadService.getPerfilSesion().pipe(
     
      map(res => {
        

        if (res) {

          const hasAutoridad = this.seguridadService.hasAutoridad(autoridades, res);

          if (hasAutoridad) {
            return true;
          }

          this.router.navigate(['/acceso-denegado']);
          return false;
          
        }

        this.router.navigate(['/login']);
        return false;

      })
    );
  }

}
